import qipLogo from "../../../../assets/images/icons/qip-logo.png";

export const QipTextBanner = ({
  title,
  copy,
  margin,
  hideLine = false,
  useCustomValue = false,
  customMarginTop = 0,
  customMarginBottom = 0,
}) => {
  let marginClass = "my-4";
  if (margin === "medium") {
    marginClass = "my-8";
  } else {
    marginClass = "my-16";
  }

  let customMarginStyle = {
    marginTop: customMarginTop,
    marginBottom: customMarginBottom,
  };

  return (
    <div
      className={`z-50 relative p-4 md:px-0 mx-auto max-w-[950px] ${useCustomValue ? "" : marginClass}`}
      style={useCustomValue ? customMarginStyle : null}
    >
      <hr
        className={`border-t border-solid ${hideLine ? "border-transparent" : "border-gray"}`}
      />
      <img
        src={qipLogo}
        alt=""
        className="absolute justify-self-center self-center"
      />

      {title && (
        <h4 className="text-gray normal-case text-center text-lg md:text-4xl m-0 mt-20 mb-7">{title}</h4>
      )}

      {copy && <p className="text-center" dangerouslySetInnerHTML={{ __html: copy }} />}
    </div>
  );
};
